import botsTemplate from './bots.html';

export default angular
  .module('main.organizations.edit.tabs.bots', [])

  .directive('editOrganizationBotsTab', () => {
    return {
      restrict: 'E',
      template: botsTemplate,
      scope: {},
      controller: ($scope,
                   $state,
                   $rootScope,
                   config,
                   $q,
                   $filter,
                   utils,
                   ToastsService,
                   EditOrganizationDataProvider) => {
        const $t = $filter('translate');
        const SELECTED_BOT_LOCAL_STORAGE_KEY = 'Selected-Bot';

        $scope.botStatuses = config.getConfigByKey('botInstanceStatuses');
        $scope.dataProvider = EditOrganizationDataProvider.instance;

        angular.extend($scope, {
          hasFeatureB: false,
          filterByBotStatus: filterByBotStatus,
          searchBots: searchBots,
          viewBot: viewBot,
          toggleBotStatus: toggleBotStatus,
          deleteBot: deleteBot,
        });

        // Remove modals
        $scope.$on('$destroy', () => {
          $('#remove-bot-dialog').remove();
        });

        init();

        function init() {
          $scope.loading = true;

          $q.all([
            $scope.dataProvider.organizationResource.init(),
            $scope.dataProvider.organizationBotsResource.init(),
          ])
            .then(() => {
              initOrganizationBots();
              $scope.loading = false;
            }, () => {
              $scope.loading = false;
            });
        }

        function initOrganizationBots(silence) {
          if (!silence) {
            $scope.loading = true;
          }

          $scope.organization = angular.copy($scope.dataProvider.organizationResource.value);
          $scope.hasFeatureB = utils.hasFeature($scope.organization, 'b');
          $scope.orgBots = angular.copy($scope.dataProvider.organizationBotsResource.value);

          if ($scope.hasFeatureB) {
            getAvailableBots();
          }
        }

        function getAvailableBots() {
          return $scope.dataProvider.searchOrganizationBots()
            .then((data) => {
              $scope.availableBots = data || [];
              $scope.loading = false;
            }, err => handleError(err));
        }

        function filterByBotStatus(item, index, array) {
          if ($scope.selectedBotStatusObj) {
            return $scope.selectedBotStatusId === item.status;
          }
          return true;
        }

        function searchBots() {
          $state.go('main.bots.list', {
            from: 'organization',
            organizationId: $scope.organization.id
          });
        }

        function viewBot(bot) {
          utils.setStorageItem(SELECTED_BOT_LOCAL_STORAGE_KEY, bot);
          $state.go('main.bots.info', {
            from: 'organization',
            organizationId: $scope.organization.id
          });
        }

        function toggleBotStatus(bot) {
          let newStatus = bot.status === 1 ? 2 : 1;

          return $scope.dataProvider.setOrganizationBotStatus(bot.appInstanceId, newStatus)
            .then(() => {
              ToastsService.success();
              $scope.$applyAsync(() => {
                const b = $scope.orgBots.find(b => b.appInstanceId === bot.appInstanceId);
                if (b) {
                  b.status = newStatus;
                }
              });
              initOrganizationBots(true);
            }, err => handleError(err));
        }

        function deleteBot(bot) {
          $scope.botDeleteMsg = $t('bots.delete.desc', {
            bot: bot.bot.name || bot.bot.bundle,
            target: $scope.organization.name,
            type: $t('orgs.list.organizationId') + $scope.organization.id
          });
          $('#remove-bot-dialog').modal({
            closable: true,
            detachable: true,
            onApprove: function() {
              return $scope.dataProvider.deleteOrganizationBot(bot.appInstanceId)
                .then(() => {
                  $scope.$applyAsync(() => {
                    $scope.orgBots = $scope.orgBots.filter(b => b.appInstanceId !== bot.appInstanceId);
                  });
                  $('#remove-bot-dialog').modal('hide');
                  ToastsService.success($t('bots.delete.success'), $t('bots.delete.successDesc'));
                  initOrganizationBots(true);
                }, err => {
                  $('#remove-bot-dialog').modal('hide');
                  handleError(err);
                });
            }
          }).modal('show');
        }

        /**
         * Handle error and stop loading
         */
        function handleError(err) {
          $scope.loading = false;
          return utils.handleApiError(err);
        }

      }
    };
  })
  .name;
